(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kindspun-product-video-loop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-panel-loop')) {
    customElements.define('ks-panel-loop', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches;
        this.inView = false;
        this.video.muted = true;
        this.video.controls = false;
        this.button.hidden = false;
        const sync = () => {
          this.button.textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        };
        const play = () => this.video.play().catch(sync);
        this.video.addEventListener('play', sync, options);
        this.video.addEventListener('pause', sync, options);
        this.video.addEventListener('error', () => {
          this.querySelector('.ks-panel-loop__error').hidden = false;
          this.button.hidden = true;
        }, options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.userPaused) this.video.pause();
          else play();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else if (this.inView && !this.userPaused) play();
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView && !this.userPaused && !document.hidden) play();
          else this.video.pause();
        }, { threshold: .2 });
        this.observer.observe(this.video);
        sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kindspun-size-visual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-sizing-loop')) customElements.define('ks-sizing-loop',class extends HTMLElement {
    connectedCallback(){
      if(this.abort)return;
      const video=this.querySelector('video'),button=this.querySelector('button');
      if(!video||!button)return;
      this.video=video;this.abort=new AbortController();
      const options={signal:this.abort.signal};
      const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      let pausedByUser=motion.matches,inView=false;
      const sync=()=>button.textContent=video.paused?this.dataset.playLabel:this.dataset.pauseLabel;
      const play=()=>{if(!video.getAttribute('src'))video.src=video.dataset.src;video.play().catch(sync);};
      video.muted=true;video.controls=false;button.hidden=false;
      video.addEventListener('play',sync,options);video.addEventListener('pause',sync,options);
      video.addEventListener('error',()=>{this.querySelector('.ks-size-film__fallback').hidden=false;button.hidden=true;},options);
      button.addEventListener('click',()=>{pausedByUser=!video.paused;if(pausedByUser)video.pause();else play();},options);
      motion.addEventListener('change',()=>{if(motion.matches){pausedByUser=true;video.pause();}},options);
      document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(inView&&!pausedByUser)play();},options);
      this.observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;if(inView&&!pausedByUser&&!document.hidden)play();else video.pause();},{threshold:.2});
      this.observer.observe(video);sync();
    }
    disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.video?.pause();this.abort=null;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
